import { render, staticRenderFns } from "./TimeshiftChannels.vue?vue&type=template&id=377a82da&"
import script from "./TimeshiftChannels.vue?vue&type=script&lang=js&"
export * from "./TimeshiftChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports